import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { jiraOauthConnect, jiraOauthStatus } from './jira.service'

const initialState = {
    connectStatus: 'idle', // idle | loading | loaded | error
    connectError: null,
    lastConnectResponse: null,
    statusFetchStatus: 'idle', // idle | loading | loaded | error
    statusFetchError: null,
    lastStatusResponse: null,
}

export const connectJiraOauth = createAsyncThunk(
    'jira/connectOauth',
    async (_, { rejectWithValue }) => {
        try {
            const response = await jiraOauthConnect()
            return response
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message)
        }
    }
)

export const fetchJiraOauthStatus = createAsyncThunk(
    'jira/status',
    async (_, { rejectWithValue }) => {
        try {
            const response = await jiraOauthStatus()
            return response
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message)
        }
    }
)

const jiraSlice = createSlice({
    name: 'jiraSlice',
    initialState,
    reducers: {
        resetJiraConnectState: (state) => {
            state.connectStatus = 'idle'
            state.connectError = null
            state.lastConnectResponse = null
        },
        resetJiraStatusState: (state) => {
            state.statusFetchStatus = 'idle'
            state.statusFetchError = null
            state.lastStatusResponse = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(connectJiraOauth.pending, (state) => {
                state.connectStatus = 'loading'
                state.connectError = null
            })
            .addCase(connectJiraOauth.fulfilled, (state, action) => {
                state.connectStatus = 'loaded'
                state.lastConnectResponse = action.payload
            })
            .addCase(connectJiraOauth.rejected, (state, action) => {
                state.connectStatus = 'error'
                state.connectError = action.payload || 'Failed to connect Jira'
            })
            .addCase(fetchJiraOauthStatus.pending, (state) => {
                state.statusFetchStatus = 'loading'
                state.statusFetchError = null
            })
            .addCase(fetchJiraOauthStatus.fulfilled, (state, action) => {
                state.statusFetchStatus = 'loaded'
                state.lastStatusResponse = action.payload
            })
            .addCase(fetchJiraOauthStatus.rejected, (state, action) => {
                state.statusFetchStatus = 'error'
                state.statusFetchError =
                    action.payload || 'Failed to fetch Jira status'
            })
    },
})

export const jiraState = (s) => s.jiraSlice || initialState
export const { resetJiraConnectState, resetJiraStatusState } =
    jiraSlice.actions
export default jiraSlice.reducer

